import { Theme } from '@mui/material';

const styles = {
  intentContainer: {
    p: 1,
    mb: 1,
    background: (theme: Theme): string => theme.palette.brand.secondary,
    fontSize: '1rem',
    borderRadius: '3px 3px 3px 0px',
    color: '#FFF',
    '& input': {
      padding: 1,
      color: '#FFF'
    },
    '& .MuiInputBase-root.Mui-disabled': {
      '& input': {
        color: '#FFF',
        WebkitTextFillColor: '#FFF'
      }
    },
    wordWrap: 'break-word',
    maxWidth: '100%'
  }
};

export default styles;
